<template>
	<div class="user-managment-edit">
		<Loading v-if="loading" />
		<div class="box">
			<span>جستجوی کاربر</span>
			<div class="mt-2">
				<input
					v-model="searchNumberInput"
					class="search-input"
					type="text"
					@input="validateMobileNumber"
					placeholder="شماره همراه"
				/>
				<button :disabled="isValidMobileNumberBtn" @click="searchUser" class="search">جستجو</button>
			</div>
		</div>
		<div>
			<div class="box">
				<span>اطلاعات کاربر</span>
				<div class="row mt-3">
					<div class="d-flex align-item.center col-lg-12 col-sm-12 mb-4">
						<div></div>
						<div class="user-name" >
							<span class="text ml-2">نام کاربری :</span>
							<span class="persian">{{ phoneNumber }}</span>
						</div>
						<!-- <Materialnput
							label="شماره تلفن همراه"
							:readonly="!isEdit"
							v-model="phoneNumber"
							inputType="number"
						/> -->
					</div>
					<div class="col-lg-6 col-sm-12">
						<Materialnput label="نام" v-model="formattedFirstName" />
					</div>
					<div class="col-lg-6 col-sm-12">
						<Materialnput label="نام خانوادگی" v-model="formattedLastName" />
					</div>
					<div class="col-lg-6 col-sm-12">
						<Materialnput label="کد ملی" v-model="formattedNationalCode" inputType="number" />
					</div>
					<!-- <div class="col-lg-6 col-sm-12">
						<Materialnput label="نقش" v-model="formattedRole" />
					</div> -->

					<div class="col-lg-6 col-sm-12">
						<Materialnput label="ایمیل" v-model="formatEmail" inputType="text" />
					</div>

					<div class="col-lg-6 col-sm-12">
						<label for="html">استان:</label>
						<select
							style="width: 100%"
							@change="getCityOnChange"
							v-model="pickProvince"
							class="search-input"
						>
							<option
								v-for="province in provinceLists"
								:value="province.id"
								:key="`province-` + province.id"
							>
								{{ province.name }}
							</option>
						</select>
					</div>
					<div class="col-lg-6 col-sm-12">
						<label for="html">شهر:</label>
						<select style="width: 100%" v-model="pickCity" class="search-input">
							<option v-for="city in cityLists" :value="city.city.id" :key="`city-` + city.city.id">
								{{ city.city.name }}
							</option>
						</select>
					</div>
					<br />
					<div class="col-lg-6 col-sm-12">
						<label for="html">نقش:</label>
						<select style="width: 100%" class="search-input" v-model="model.role.id">
							<option v-for="role in roles" :key="role.id + `-role-`" :value="role.id">
								{{ role.verbose_name }}
							</option>
						</select>
					</div>
				</div>
				<div class="d-flex justify-content-end">
					<button @click="submitHandler" class="submit-btn">ثبت و ذخیره</button>
					<!-- <button @click="searchUser" class="search">ثبت</button> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Materialnput from '../../components/MaterialInput/indx.vue';
import Loading from '../../components/Loading/index.vue';

export default {
	components: {
		Materialnput,
		Loading,
	},
	data() {
		return {
			model: {
				user: {
					first_name: null,
					last_name: null,
					username: null,
					email: null,
					extended: {
						national_code: null,
					},
				},
				role: {
					id: null,
					verbose_name: null,
				},
			},
			phoneNumber: null,
			searchNumberInput: '',
			isEdit: false,
			isValidMobileNumber: false,
			loading: false,
			roles: [],
			cityLists: [],
			provinceLists: [],
			pickCity: '',
			pickProvince: '',
			selectedkCity: '',
		};
	},
	created() {
		this.getPhoneNumber();
	},
	mounted() {
		this.getProfileDetail();
		this.getRoles();
		this.getProvince();
	},
	computed: {
		isValidMobileNumberBtn() {
			// Regular expression for Iranian mobile numbers
			const iranMobileRegex = /^(\+98|0)?9\d{9}$/;

			// Check if the entered mobile number matches the regex
			const x = iranMobileRegex.test(this.searchNumberInput);
			if (x === false) {
				return true;
			} else {
				return false;
			}
		},
		formattedFirstName: {
			get() {
				// Check if model and user are defined before accessing properties
				if (this.model && this.model.user && this.model.user.first_name !== null) {
					return this.model.user.first_name;
				} else {
					return '';
				}
			},
			set(value) {
				// Ensure model and user are defined before updating
				if (this.model && this.model.user) {
					this.$set(this.model.user, 'first_name', value);
				}
			},
		},
		formattedLastName: {
			get() {
				// Check if model and user are defined before accessing properties
				if (this.model && this.model.user && this.model.user.last_name !== null) {
					return this.model.user.last_name;
				} else {
					return '';
				}
			},
			set(value) {
				// Ensure model and user are defined before updating
				if (this.model && this.model.user) {
					this.$set(this.model.user, 'last_name', value);
				}
			},
		},
		formattedNationalCode: {
			get() {
				// Check if model and user are defined before accessing properties
				if (
					this.model &&
					this.model.user.extended &&
					this.model.user.extended.national_code !== null
				) {
					return this.model.user.extended.national_code;
				} else {
					return '';
				}
			},
			set(value) {
				// Ensure model and user are defined before updating
				if (this.model && this.model.user.extended) {
					this.$set(this.model.user.extended, 'national_code', value);
				}
			},
		},
		// formattedRole: {
		// 	get() {
		// 		// Check if model and user are defined before accessing properties
		// 		if (this.model && this.model.role && this.model.role.verbose_name !== null) {
		// 			return this.model.role.id;
		// 		} else {
		// 			return '';
		// 		}
		// 	},
		// 	set(value) {
		// 		// Ensure model and user are defined before updating
		// 		if (this.model && this.model.role) {
		// 			this.$set(this.model.role.verbose_name, 'verbose_name', value);
		// 		}
		// 	},
		// },
		formatUserName: {
			get() {
				// Check if model and user are defined before accessing properties
				if (this.model && this.model.user && this.model.user.username !== null) {
					return this.model.user.username;
				} else {
					return '';
				}
			},
			set(value) {
				// Ensure model and user are defined before updating
				if (this.model && this.model.user) {
					this.$set(this.model.user.username, 'username', value);
				}
			},
		},
		formatEmail: {
			get() {
				// Check if model and user are defined before accessing properties
				if (this.model && this.model.user && this.model.user.email !== null) {
					return this.model.user.email;
				} else {
					return '';
				}
			},
			set(value) {
				// Ensure model and user are defined before updating
				if (this.model && this.model.user) {
					this.$set(this.model.user, 'email', value);
				}
			},
		},
	},
	methods: {
		getPhoneNumber() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			if (lastParam === 'add') {
				this.phoneNumber = null;
			} else {
				this.phoneNumber = lastParam;
				this.searchNumberInput = lastParam;
			}
		},
		async getProfileDetail() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.GET_USER_LIST +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId +
					'&user__username=' +
					this.phoneNumber,
				this.$PATH.SERVICE_NAME.EMPTY,
			);
			if (res.status === 200) {
				if (res.data.length === 0) {
					this.model = {
						user: {
							first_name: null,
							last_name: null,
							username: this.searchNumberInput,
							email: null,
							extended: {
								national_code: null,
							},
						},
						role: {
							id: null,
							verbose_name: null,
						},
					};
				} else {
					this.model = res.data[0];
					this.pickCity = res.data[0].user.extended.city.id;
					this.pickProvince = res.data[0].user.extended.city.province.id;
					this.selectedkCity = this.pickProvince;
					this.pickCity;
				}
				this.getCity();
			}
		},
		async searchUser() {
			this.loading = true;
			this.phoneNumber = this.searchNumberInput;
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.GET_USER_LIST +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId +
					'&user__username=' +
					this.searchNumberInput +
					'&is_deleted=false',
				this.$PATH.SERVICE_NAME.EMPTY,
			);
			if (res.status === 200) {
				if (res.data.length === 0) {
					const res2 = await this.$ApiServiceLayer.get(
						this.$PATH.RELATIVE_PATH.GET.GET_USER_LIST +
							'?user__username=' +
							this.searchNumberInput +
					'&p=' +
					this.$STORE.state.userConfig.setProjectId,
						this.$PATH.SERVICE_NAME.EMPTY,
					);
					if (res2.status === 200) {
						if (res2.data.length === 0) {
							this.loading = false;
							this.model.user.first_name = null;
							this.model.user.last_name = null;
							this.model.user.extended.national_code = null;
							this.model.role.verbose_name = null;
							this.model.user.username = null;
							this.model.user.email = null;
							this.pickCity = null;
							this.pickProvince = null
							this.model.role = {
								id: null,
								verbose_name: null,
							};
							this.$notify({
								group: 'tc',
								type: 'warning',
								text: 'کاربر مورد نظر یافت نشد ،برای ثبت آن فرم اطلاعات کاربر را تکمیل کنید.',
							});
						} else if (res2.data.length > 0) {
							this.loading = false;
							this.model = res2.data[0];
							this.pickCity = res2.data[0].user.extended.city.id;
							this.pickProvince = res2.data[0].user.extended.city.province.id;
							this.selectedkCity = this.pickProvince;
							this.model.role = {
								id: null,
								verbose_name: null,
							};
							this.$notify({
								group: 'tc',
								type: 'warning',
								text: 'برای ثبت این کاربر نقش وی را در این پروژه انتخاب کرده و دکمه ثبت و ذخیره را بزنید.',
							});
						}
					}
				} else if (res.data.length > 0) {
					this.loading = false;
					this.model = res.data[0];
					this.pickCity = res.data[0].user.extended.city.id;
					this.pickProvince = res.data[0].user.extended.city.province.id;
					this.selectedkCity = this.pickProvince;
				}
			}
		},
		async getRoles() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.LIST_CREATE_ROLE +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.roles = res.data;
				'here roles:', this.roles;
			}
		},
		getCityOnChange() {
			this.selectedkCity = this.pickProvince;
			'ci', this.selectedkCity;
			this.getCity();
		},
		async getProvince() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.GET_PROVINCE_LIST +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.provinceLists = res.data;
			}
		},
		async getCity() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.GET_CITY_LIST +
					'?city__province=' +
					this.selectedkCity +
					'&p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				'city:', res.data;
				this.cityLists = res.data;
			}
		},
		validateMobileNumber() {
			// Remove non-digit characters from the input
			this.searchNumberInput = this.searchNumberInput.replace(/\D/g, '');

			// Limit the input to 11 characters
			if (this.searchNumberInput.length > 11) {
				this.searchNumberInput = this.searchNumberInput.slice(0, 11);
			}

			// Define the regex pattern for an Iranian mobile number
			const iranMobileRegex = /^09\d{9}$/;

			// Test the input against the regex pattern
			this.isValidMobileNumber = iranMobileRegex.test(this.searchNumberInput);
		},
		async submitHandler() {
			'dssdd', this.pickCity;
			const data = {
				change_password: false,
				user: {
					username: this.phoneNumber,
					email: this.model.user.email,
					first_name: this.model.user.first_name,
					last_name: this.model.user.last_name,
					extended: {
						national_code: this.model.user.extended.national_code,
						city: this.pickCity,
					},
				},
				role: this.model.role.id,
				project: this.$STORE.state.userConfig.setProjectId,
			};
			'dssdd', data;
			const res = await this.$ApiServiceLayer.post(
				this.$PATH.RELATIVE_PATH.POST.POST_USER_LIST +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.EMPTY,
				data,
			);
			res;
			if (res.status === 200) {
				this.$notify({
					group: 'tc',
					type: 'success',
					text: 'اطلاعات کاربر با موفقیت ذخیره شد.',
				});
			}
		},
	},
	watch: {
		'model.user.first_name': {
			immediate: true,
			handler(newValue) {
				// Ensure the model and user are defined before checking for null
				if (this.model && this.model.user && newValue === null) {
					this.formattedFirstName = ''; // Set to empty string if null
				}
			},
		},
		'model.user.last_name': {
			immediate: true,
			handler(newValue) {
				// Ensure the model and user are defined before checking for null
				if (this.model && this.model.user && newValue === null) {
					this.formattedLastName = ''; // Set to empty string if null
				}
			},
		},
		'model.user.extended.national_code': {
			immediate: true,
			handler(newValue) {
				// Ensure the model and user are defined before checking for null
				if (this.model && this.model.user.extended && newValue === null) {
					this.formattedNationalCode = ''; // Set to empty string if null
				}
			},
		},
		'model.role.verbose_name': {
			immediate: true,
			handler(newValue) {
				// Ensure the model and user are defined before checking for null
				if (this.model && this.model.role && newValue === null) {
					this.formattedRole = ''; // Set to empty string if null
				}
			},
		},
		'model.user.username': {
			immediate: true,
			handler(newValue) {
				// Ensure the model and user are defined before checking for null
				if (this.model && this.model.user && newValue === null) {
					this.formatUserName = ''; // Set to empty string if null
				}
			},
		},
		'model.user.email': {
			immediate: true,
			handler(newValue) {
				// Ensure the model and user are defined before checking for null
				if (this.model && this.model.user && newValue === null) {
					this.formatEmail = ''; // Set to empty string if null
				}
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.user-managment-edit {
	padding: 32px 50px;

	.box {
		padding: 24px;
		border-radius: 8px;
		margin-bottom: 16px;
		background: #fff;
		border-radius: 8px;
		box-shadow: none;
		.user-name {
			display: flex;
			align-items: center;
			width: 100%;
			background:#f1f1f1;
			border-radius: 8px;
			padding: 12px;
			.text {
				font-size: 12px;
			}
		}
		.search-input {
			text-indent: 10px;
			height: 40px;
			border: 1px solid #c4c4c4;
			padding: 0 9px;
			border-radius: 8px;
			font-family: 'IRANYekanfa' !important;
			border-radius: 8px;
			margin: 8px 4px;
		}

		.search {
			border: 1px solid #2d8b8b;
			background: #fff;
			color: #000;
			min-width: 75px;
			border-radius: 8px;
			color: #2d8b8b;
			padding: 8px;
			margin-right: 8px;
			&:disabled {
				background: #f1f1f1;
				color: #535656;
				border-radius: 8px;
				border: none;
				padding: 8px;
			}
		}
		.submit-btn {
			border: 1px solid #2d8b8b;
			background: #2d8b8b;
			color: #000;
			min-width: 75px;
			border-radius: 8px;
			color: #fff;
			padding: 8px;
			margin-right: 8px;
		}
		.persian {
			font-family: 'IRANYekanfa' !important;
		}
		// .dropdown-select {
		// 	he
		// }
	}
}
</style>
